const config = {
  app: process.env.VUE_APP_TYPE || 'code',
  initial: {
    course: {
      start: 'start',
      lecture: 'lecture',
      video: 'video',
      materials: 'materials',
      finish: 'finish',
      exam: 'exam',
    },
  },
};

export default config;
